
export default {
  props: {
    title: {
      type: String,
      default: "Cancel"
    }
  }
};
